import { render } from "./alloverTaxReportOwners.vue?vue&type=template&id=b079c638&scoped=true"
import script from "./alloverTaxReportOwners.vue?vue&type=script&lang=js"
export * from "./alloverTaxReportOwners.vue?vue&type=script&lang=js"

import "./alloverTaxReportOwners.vue?vue&type=style&index=0&id=b079c638&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b079c638"]])

export default __exports__